<script>
import appConfig from "@/app.config";
import Common from "@/components/common";
export default {
  components: {
    Common
  },
  data() {
    return {
      baseCurrency: appConfig.baseCurrency,
      userData:{},
      indiaTime: '',
      malaysiaTime: '',
      usTime: '',
    };
  },
  mounted() {
    this.userData = this.$refs.commonFunc.getFullData();
    this.updateTimes();
    // Update times every second (you can adjust the interval as needed)
    setInterval(this.updateTimes, 1000);
  },
  methods: {
    /**
     * Toggle menu
     */
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */
        !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    /**
     * Toggle rightsidebar
     */
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    /**
     * Set languages
     */
    setLanguage(locale, country, flag) {
      this.$i18n.locale = locale;
      this.current_language = locale;
      this.text = country;
      this.flag = flag;
    },
    updateTimes() {
      const indiaTimeZoneOffset = 5.5 * 60 * 60 * 1000; // India is UTC+5.5
      const malaysiaTimeZoneOffset = 8 * 60 * 60 * 1000; // Malaysia is UTC+8
      const usZoneOffset = -4 * 60 * 60 * 1000; // Malaysia is UTC+8

      const now = new Date();
      const indiaTime = new Date(now.getTime() + indiaTimeZoneOffset);
      const malaysiaTime = new Date(now.getTime() + malaysiaTimeZoneOffset);
      const usTime = new Date(now.getTime() + usZoneOffset);

      const indiaTimeFormatted = `${indiaTime.toISOString().slice(0, 10)} ${indiaTime.toISOString().slice(11, 19)}`;
      const malaysiaTimeFormatted = `${malaysiaTime.toISOString().slice(0, 10)} ${malaysiaTime.toISOString().slice(11, 19)}`;
      const usTimeFormatted = `${usTime.toISOString().slice(0, 10)} ${usTime.toISOString().slice(11, 19)}`;
      this.indiaTime = indiaTimeFormatted;
      this.malaysiaTime = malaysiaTimeFormatted;
      this.usTime = usTimeFormatted;
    },
  },
};
</script>

<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <router-link to="/" class="logo logo-dark">
            <span class="logo-sm">
              <img src="@/assets/images/logo-sm.png" alt height="48" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo-dark.png" alt height="48" />
            </span>
          </router-link>

          <router-link to="/" class="logo logo-light">
            <span class="logo-sm">
              <img src="@/assets/images/logo-sm-light.png" alt height="42" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo-light.png" alt height="42" />
            </span>
          </router-link>
        </div>

        <button
          @click="toggleMenu"
          type="button"
          class="btn btn-sm px-3 font-size-22 header-item vertical-menu-btn"
          id="vertical-menu-btn"
        >
        <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAT0lEQVR4nO3WwQkAIAwDwIzezesWKuEO8jf4aBIAHpmSZEuS1w9QJK0/MiUBAPLBRTbj0zoatySpKTIlAQDywUU249M6GrckqSkyJQEg1x3OPOvHECpbTAAAAABJRU5ErkJggg==" height="15">
        </button>

        <!-- App Search-->
        
      </div>

      <div class="d-flex">

        <b-dropdown
          class="d-inline-block"
          toggle-class="header-item"
          right
          variant="white"
          menu-class="dropdown-menu-end"
        >
          <template v-slot:button-content>
            <img
              class="rounded-circle header-profile-user"
              src="@/assets/images/user.png"
              alt="Header Avatar"
            />
            <span
              class="ms-1 fw-medium font-size-15"
              > {{userData.name}}</span
            >
            <i class="uil-angle-down d-none d-xl-inline-block font-size-15"></i>
          </template>

         
          <!-- <router-link to="/" class="dropdown-item d-block">
            <i
              class="uil uil-cog font-size-18 align-middle me-1 text-muted"
            ></i>
            <span class="align-middle">Activity Log</span>
          </router-link> -->
          <router-link  :to="{ name: 'profile'}" class="dropdown-item">
            <i
              class="bi bi-person-lock font-size-18 align-middle me-1 text-muted"
            ></i>
            <span class="align-middle">Change Password</span>
          </router-link>
          <router-link :to="{ name: 'logout'}"  class="dropdown-item">
            <i
              class="bi bi-box-arrow-right font-size-18 align-middle me-1 text-muted"
            ></i>
            <span class="align-middle">{{$t("siteLang.Logout") }}</span>
          </router-link>

          <div class="dropdown-item py-3 mt-2 pb-2 border-top bg-white">
            <div class="d-flex mb-2">
                <div class="me-2">
                <img
                  class="me-1"
                  src="@/assets/images/flags/in.png"
                  alt="India"
                  height="11"
                  width="20"
                />
                 India</div>
                <div class="ms-auto">{{ indiaTime }}</div>
            </div>
            <div class="d-flex mb-2" v-if="baseCurrency=='HKD'">
                <div class="me-2">
                  <img
                    class="me-1"
                    src="@/assets/images/flags/hk.png"
                    alt="Hong Kong"
                    height="11"
                    width="20"
                  />
                  Hong Kong</div>
                <div class="ms-auto">{{ malaysiaTime }}</div>
            </div>
            <div class="d-flex mb-2" v-else>
                <div class="me-2">
                  <img
                    class="me-1"
                    src="@/assets/images/flags/my.png"
                    alt="Malaysia"
                    height="11"
                    width="20"
                  />
                  Malaysia</div>
                <div class="ms-auto">{{ malaysiaTime }}</div>
             </div>
            <div class="d-flex">
                <div class="me-2">
                  <img
                    class="me-1"
                    src="@/assets/images/flags/us.png"
                    alt="United States"
                    height="11"
                    width="20"
                  />
                  United States</div>
                <div class="ms-auto">{{ usTime }}</div>
            </div>
          </div>
        </b-dropdown>

    

      </div>
    </div>
    <Common ref="commonFunc"/>
  </header>
</template>
